/**
 * 将JSON文件对应的label配置转换成i18n
 * @param input JSON配置文件
 * @param wrapperKey i18n的命名层级空间，不传就是全局命名空间
 */
export const transformJsonToI18n = (
  input: Record<string, { name?: string; i18n: Record<string, string> }>,
  wrapperKey?: string,
) => {
  const localeMap = Object.entries(input).reduce<
    Record<string, Record<string, string>>
  >((acc, [code, entry]) => {
    Object.entries(entry.i18n).forEach(([locale, label]) => {
      (acc[locale] ??= {})[code] = label;
    });
    return acc;
  }, {});

  if (!wrapperKey) return localeMap;

  return Object.fromEntries(
    Object.entries(localeMap).map(([locale, map]) => [
      locale,
      { [wrapperKey]: map },
    ]),
  );
};
